import React, { useMemo, useState, useCallback } from 'react';

export function useReportTableSort(list, defaultKey = 'roi', defaultDir = 'desc') {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);

  const onSort = useCallback((key) => {
    if (sortKey === key) {
      setSortDir((prevDir) => (prevDir === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir(key === 'symbol' ? 'asc' : 'desc');
    }
  }, [sortKey]);

  const sortedList = useMemo(() => {
    const items = Array.isArray(list) ? [...list] : [];
    const dir = sortDir === 'asc' ? 1 : -1;

    items.sort((a, b) => {
      if (sortKey === 'symbol') {
        return dir * String(a.symbol || '').localeCompare(String(b.symbol || ''), undefined, {
          sensitivity: 'base',
        });
      }

      const field = sortKey === 'count'
        ? 'count'
        : sortKey === 'pl'
          ? 'pl'
          : sortKey === 'price'
            ? 'price'
            : 'roi';
      const aVal = Number(a[field]) || 0;
      const bVal = Number(b[field]) || 0;
      if (aVal === bVal) {
        return String(a.symbol || '').localeCompare(String(b.symbol || ''));
      }
      return dir * (aVal - bVal);
    });

    return items;
  }, [list, sortKey, sortDir]);

  return { sortedList, sortKey, sortDir, onSort };
}

export function SortableReportTh({ label, sortKey, activeKey, sortDir, onSort, align }) {
  const isActive = activeKey === sortKey;
  const indicator = !isActive ? '↕' : sortDir === 'asc' ? '↑' : '↓';

  return (
    <th align={align} className="report-sortable-th">
      <button
        type="button"
        className={`report-sort-btn${isActive ? ' report-sort-btn--active' : ''}`}
        onClick={() => onSort(sortKey)}
      >
        {label}
        <span className="report-sort-indicator" aria-hidden="true">{indicator}</span>
      </button>
    </th>
  );
}
